import React, { useEffect, useState } from 'react';
import { FlameIcon } from 'lucide-react';
const TOTAL_SPOTS = 200;
export function ScarcityBar() {
  const [spotsLeft, setSpotsLeft] = useState(13);
  useEffect(() => {
    const id = window.setInterval(() => {
      setSpotsLeft(prev => prev <= 6 ? 13 : prev - 1);
    }, 25000);
    return () => window.clearInterval(id);
  }, []);
  const takenPct = Math.round((TOTAL_SPOTS - spotsLeft) / TOTAL_SPOTS * 100);
  return <div className="w-full max-w-md mx-auto" data-id="element-52" data-mp="2b8us9sqzoi0x">
      <div className="flex items-center justify-between gap-3 text-[11.5px] sm:text-xs font-bold uppercase tracking-wide" data-id="element-53" data-mp="2g6ctsy2ofuyw">
        <span className="flex items-center gap-1.5 text-alert-600" data-id="element-54" data-mp="227ddcdpbimdt">
          <FlameIcon className="w-4 h-4" aria-hidden="true" data-id="element-55" data-mp="274n1zr4vuu0l" />
          Quedan {spotsLeft} cupos
        </span>
        <span className="text-navy-600/60 normal-case tracking-normal font-semibold" data-id="element-56" data-mp="efhe908vdon">
          {takenPct}% reclamado
        </span>
      </div>
      <div className="mt-2 h-3 w-full overflow-hidden rounded-full bg-navy-100" role="progressbar" aria-valuenow={takenPct} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos reclamados al precio promocional" data-id="element-57" data-mp="5bpe89pyqrmi">
        <div className="h-full rounded-full bg-alert-500 transition-all duration-700" style={{
        width: `${takenPct}%`
      }} data-id="element-58" data-mp="3dbd4ms7nv255" />
      </div>
      <p className="mt-2 text-center text-[11.5px] sm:text-xs text-navy-700/70 font-medium" data-id="element-59" data-mp="2knqzvgmp5rgp">
        Solo <strong className="text-alert-600" data-id="element-60" data-mp="2gmp0mzss5feq">{spotsLeft} cupos</strong> disponibles al precio
        promocional de USD 15. Al agotarse, el valor vuelve a USD 97.
      </p>
    </div>;
}